import React from 'react';
import { Route, Link } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import SignatureManage from '@/components/SignatureManage';
import AddSignature from '@/components/SignatureManage/AddSignature';
import Nav from '@/components/Nav';
import { getQueryString } from '@/utils/tools';
import './style.less';
const { Sider, Content} = Layout;
const clsPrefix = 'MessagePage';

const getSelectedKeyByRoute = () => {
    let currentRoute = window.location.pathname;
    let selectedKey = null;
    switch (currentRoute) {
        case "/v5/message":
            selectedKey = ["1"];
            break;
        default:
            selectedKey = ["1"];
            break;
    }
    return selectedKey;
}

const siteId = getQueryString('siteId');

const MessagePage = ({ match }) => (
    <React.Fragment>
        <Nav />
        <Layout style={{ maxHeight: "0"}}>
            <Sider className={`${clsPrefix}-sider`} theme="light">
                <Menu 
                    theme="light"
                    mode="inline"
                    defaultSelectedKeys={getSelectedKeyByRoute()}
                    >
                    <Menu.Item key="1">
                        <Link to={`/v5/message?siteId=${siteId}`}>签名管理</Link>
                    </Menu.Item>
                </Menu>
            </Sider>
            <Content className={`${clsPrefix}-content`}>
                <SignaturePage match={match} />
            </Content>
        </Layout>
    </React.Fragment>
);

const SignaturePage = ({ match }) => (
    <div>
        <Route exact path={`${match.url}`} component={SignatureManage}></Route>
        <Route path={`${match.url}/addSignature`} component={AddSignature}></Route>
    </div>
)
export default MessagePage;